import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../common/Footer";
import Navigation from "../common/Navigation";
import Sidebar from "../common/Sidebar";
import CommonService from "../../services/CommonService";
import Swal from "sweetalert2";
import FormInput from "../common/FormInput";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

const AioAadhar = () => {
  const nav = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const formRef = useRef(null);

  //  Yup validation schema
  const schema = Yup.object({
    aadhar: Yup.string()
      .required("Aadhaar number is required")
      .matches(/^[0-9]{12}$/, "Aadhaar must be a 12-digit number"),
  });

  //  React Hook Form setup
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onTouched",
  });

  //  Reset form handler
  const handleCancel = () => {
    reset();
  };

  //  Submit handler
 const onSubmit = async (data) => {
  setIsLoading(true);

  const payload = {
    aadhaar_no: data.aadhar,
  };

  try {
    const response = await CommonService.aadharOtp(payload);

    if (response?.data?.status === 200 && response?.data?.data?.checkotpDetails) {
      localStorage.setItem("urn", response.data.data.urn);
      localStorage.setItem("ref_id", response.data.data.checkotpDetails.ref_id);

      Swal.fire({
        icon: "success",
        title: response.data.data.checkotpDetails.status,
        text: "OTP sent successfully on registered mobile number.",
      });

      nav("/aio-aadhar-verify");
    } else {
      Swal.fire({
        icon: "error",
        title: response?.data?.status || "Error",
        text: response?.data?.message || "Unexpected response from server.",
      });
    }
  } catch (error) {
    console.error("Aadhaar OTP API error:", error);

    const status = error?.response?.data?.status || error?.code || "Error";
    const message =
      error?.response?.data?.message ||
      error?.message ||
      "Something went wrong. Please try again.";

    Swal.fire({
      icon: "error",
      title: status,
      text: message,
    });
  } finally {
    setIsLoading(false);
  }
};

    return (
        <>
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
                <Sidebar/>
                <div className="layout-page">
                    <Navigation/>
                    <div className="content-wrapper">
                        <div className="container-xxl flex-grow-1 container-p-y">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card h-100">
                                        <div className="card-body"> 
                                            <div className="row">
                                                <h5 className="card-header">Aio Aadhar Report</h5>
                                                <hr className="hr-line"/>
                                            </div>
                                            {isLoading ? (
                                                <div className="d-flex justify-content-center">
                                                    <div className="sk-fold sk-primary">
                                                        <div className="sk-fold-cube"></div>
                                                        <div className="sk-fold-cube"></div>
                                                        <div className="sk-fold-cube"></div>
                                                        <div className="sk-fold-cube"></div>
                                                    </div>
                                                </div>
                                            ) : ( 
                                            <form className="card-body" ref={formRef} style={{paddingTop:"0px", paddingLeft:"0px"}} data-parsley-validate="" onSubmit={ handleSubmit(onSubmit) }>
                                                <div className="row">    
                                                    <div className="col-md-4">
                                                       <FormInput
                                label="Aadhaar Number"
                                name="aadhar"
                                register={register}
                                errors={errors}
                                placeholder="Enter Aadhaar number"
                                maxLength={12}
                              />
                                                    </div>
                                                </div>
                                               <div className="pt-4">
                                                    <button type="submit" className="btn btn-primary me-sm-3 me-1">Find Status</button>
                                                    <button type="button" className="btn btn-label-secondary" onClick={handleCancel}>Reset</button>
                                                </div>
                                            </form> 
                                            )} 
                                        </div>
                                    </div>    
                                </div>
                             </div> 
                        </div>
                        <Footer/>
                        <div className="content-backdrop fade"></div>
                    </div>
                </div>
            </div>
            <div className="layout-overlay layout-menu-toggle"></div>
            <div className="drag-target"></div>
        </div>    
    </>
    )
}   

export default AioAadhar;